import { render, staticRenderFns } from "./AssignmentForm.vue?vue&type=template&id=01267ace&scoped=true"
import script from "./AssignmentForm.vue?vue&type=script&lang=js"
export * from "./AssignmentForm.vue?vue&type=script&lang=js"
import style0 from "./AssignmentForm.vue?vue&type=style&index=0&id=01267ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01267ace",
  null
  
)

export default component.exports